import slice from "./informationSlice";

export default slice.reducer;
